export default __webpack_public_path__ + "2187f2d2196523988a89cd3275830d80.png";